import { connect } from 'react-redux';
import RocheVolumeTransactionsScreen from '../components/RocheVolumeTransactionsScreen';
import actions from '../../actions';

const mapStateToProps = (state) => ({
    transactions: state.transaction?.filteredResults,

    total: state.transaction.total,
    totalPages: state.transaction.totalPages,
    currentPage: state.transaction.current,

    allTransactions: state.transaction.results,
    filteredTransactionsBySearch: state.transaction.filteredResultsBySearch,

    loading: state.transaction.getTransactionsStatus.loading,
    downloadStatus: state.transaction.downloadTransactionsStatus,

    validatePaymentsStatus: state.transaction.validateVolumePaymentsStatus,
    sendNexStatus: state.transaction.sendNexStatus,

    payStatus: state.transaction.payVolumeStatus,
    payResults: state.transaction.lastPayVolumeResults, //Lista de transacciones que fueron exitosas/errores
    trackPaymentsErrorsStatus: state.transaction.trackVolumePaymentsErrorsStatus, //Lista de track Payments que fueron erronoeas/canceladas
    rejectStatus: state.transaction.rejectVolumeTransactionsStatus,

    userIsPayer: state.profile.user.groups?.includes('pagadores'),
    userType: state.profile.user.type,
    userPrivateKey: state.profile.user.privateKey,

    walletDetails: state.wallet.data,
});

const mapDispatchToProps = (dispatch) => ({
    getVolumeTransactions: (filter, page, search, startDate, endDate, order) =>
        dispatch(
            actions.transaction.getVolumeTransactionsByFilters(
                filter,
                page,
                search,
                startDate,
                endDate,
                order,
            ),
        ),

    updateFilterValues: (filter) => dispatch(actions.transaction.updateFilterValues(filter)),
    getWalletDetails: () => dispatch(actions.wallet.getWalletDetails()),

    updatePage: (pageNumber) => dispatch(actions.transaction.updatePage(pageNumber)),
    updatePageSize: (pageSize) => dispatch(actions.transaction.updatePageSize(pageSize)),

    searchTransactions: (search) => dispatch(actions.transaction.searchTransactions(search)),

    updateFilteredTransactionsByDateRange: (newResults) =>
        dispatch(actions.transaction.updateFilteredTransactionsByDateRange(newResults)),
    clearDateRangeSelection: (textToSearch) =>
        dispatch(actions.transaction.clearDateRangeSelection(textToSearch)),

    downloadTransactions: (
        transactionType,
        sortedFilteredResults,
        filter,
        page,
        search,
        startDate,
        endDate,
        order,
    ) =>
        dispatch(
            actions.transaction.downloadRocheVolumeTransactions(
                transactionType,
                sortedFilteredResults,
                filter,
                page,
                search,
                startDate,
                endDate,
                order,
            ),
        ),

    validatePayments: (transactionsIds) =>
        dispatch(actions.transaction.validateVolumePayments(transactionsIds)),

    pay: (transactions) => dispatch(actions.transaction.payVolume(transactions)),

    sendMultipleNex: (transactions) => dispatch(actions.transaction.sendMultipleNex(transactions)),

    trackPaymentsErrors: (transactionsIds) =>
        dispatch(actions.transaction.trackVolumePaymentsErrors(transactionsIds)),

    clearUI: () => dispatch(actions.transaction.clearUI()),

    rejectTransactions: (transactionsIds) =>
        dispatch(actions.transaction.rejectVolumeTransactions(transactionsIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RocheVolumeTransactionsScreen);
